export const CREATE_TRIBUTE_GROUP = 'CREATE_TRIBUTE_GROUP';
export const UPSERT_TRIBUTE_GROUP = 'UPSERT_TRIBUTE_GROUP';
export const EDIT_TRIBUTE_GROUP = 'EDIT_TRIBUTE_GROUP';
export const DELETE_TRIBUTE_GROUP = 'DELETE_TRIBUTE_GROUP';
export const LIST_TRIBUTES_GROUPS = 'LIST_TRIBUTES_GROUPS';